
<template>
    <Form ref="form"
          :rules="rule"
          :model="formData"
          :label-width="124"
          class="sfsform">
        <FormItem :label="$t('已用容量')+':'"
                  style="margin-bottom: 5px;">
            {{data.usedSize}}GB
        </FormItem>
        <FormItem :label="$t('当前容量')+':'"
                  style="margin-bottom: 5px;">
            {{data.size}}GB
        </FormItem>
        <FormItem :label="$t('调整后容量')+':'"
                  prop="changesize">
            <Input style="width:60px;"
                   @on-blur="sfsDataChange"
                   v-model="formData.changesize"></Input>&nbsp;GB
            <!-- <Tooltip theme="light"
                     placement="top"
                     style="margin:0px 0 0 3px;vertical-align: middle;cursor: pointer;">
                <i class="icon-prompt-1-o tips-icon-prompt"></i>
                <div slot="content">
                    <p>{{$t('每天只能扩缩容1次')}}</p>
                    <p>{{$t('每周扩缩容次数不得多于')}}{{maxTimes}}{{$t('次')}}</p>
                    <p>{{$t('每次扩缩容限制不得大于')}}{{maxTimesStorage}} GB</p>
                    <p>{{$t('调整后容量必须大于已使用容量')}}</p>
                </div>
            </Tooltip> -->
            <div class="instruction">
                <p>
                    {{$t('每七天可扩容')}}{{maxUpgradeCount}}{{$t('次')}}，{{$t('缩容')}}{{maxDegradeCount}}{{$t('次')}}
                </p>
                <p>{{$t('调整后容量必须大于已使用容量')}}</p>
                <p>{{$t('每次扩缩容限制不得大于')}}{{maxTimesStorage}} GB</p>
            </div>
        </FormItem>
    </Form>
</template>

<script>
import API from '@/service/api.js'
export default {
    name: 'sfsform',
    props: ['data', 'type'],
    data () {
        return {
            maxTimesStorage: 0,
            // minTimesStorage: 0,
            maxTimes: 0,
            formData: {
                changesize: '0'
            },
            rule: {
                changesize: [
                    { required: true, message: '这是必填字段', trigger: 'blur' },
                    {
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            const reg = /^[1-9]+[0-9]*$/
                            if (Number(value) <= Number(this.data.usedSize)) {
                                callback(this.$i18n.t('调整后容量必须大于已使用容量'))
                            } else if (Math.abs(Number(this.data.size) - Number(value)) > Number(this.maxTimesStorage)) {
                                callback(this.$i18n.t('每次扩缩容限制不得大于' + this.maxTimesStorage + 'GB'))
                            } else if (Number(this.data.size) === Number(value)) {
                                callback(this.$i18n.t('调整后容量不能和当前容量相同'))
                            } else if (!reg.test(value)) {
                                callback(new Error(this.$t('请输入整数')))
                            } else {
                                callback()
                            }
                        }
                    }
                ]
            },
            maxUpgradeCount: 0,
            maxDegradeCount: 0
        }
    },
    created () {
        this.getConfig()
        this.formData.changesize = this.data.size ? String(this.data.size) : '0'
    },
    mounted () {
        this.$nextTick(() => {
            this.$emit('sfsData', this.formData)
        })
    },
    methods: {
        getConfig () {
            this.axios.get(this.urlFormat(API.PUT_ALL_CONFIG + '?configTypes=other_config&configTypes=hpc_config&configTypes=sfs_config', true)).then(res => {
                res.forEach(element => {
                    if (element.configKey === 'hpc.sfs.base.config') {
                        let list = JSON.parse(element.configValue) || []
                        list = list.find(item => item.serviceType === this.type)
                        this.maxTimesStorage = list.changeMaxCapacity
                        this.maxUpgradeCount = list.maxUpgradeCount
                        this.maxDegradeCount = list.maxDegradeCount
                    }
                    if (element.configKey === 'hpc.sfs.max.times') {
                        this.maxTimes = element.configValue
                    }
                })
            })
        },
        sfsDataChange () {
            this.$refs.form && this.$refs.form.validate((v) => {
                if (v) {
                    this.$emit('sfsData', this.formData)
                }
            })
        }
    }
}
</script>
<style lang="less">
.sfsform {
    .instruction {
        padding-top: 8px;
        color: #999999;
        line-height: 20px;
    }
}

.ivu-form.sfsform .ivu-form-item-label {
    color: #999;
}
</style>
